'use strict';
const cryptoRandomString = require('crypto-random-string');

module.exports = () => cryptoRandomString(32);



//////////////////
// WEBPACK FOOTER
// ./node_modules/unique-string/index.js
// module id = M6gx
// module chunks = 0